<script>
import {addStorageFees, getWarehouseByShipmentNumber} from "@/api/order/firstOrder";

export default {
  name: "StorageFee",
  props: {
    close: {
      type: Function,
      default: () => {}
    },
    refresh:{
      type: Function,
      default: () => {}
    }
  },
  methods: {
    updateAmount() {
      // 浮点相乘会产出超长小数位，先放大 100 倍四舍五入再缩小，只保留两位小数
      this.form.amount = Math.round(this.form.price * this.form.period * this.form.volume * 100) / 100;
    },
    // 收费天数：大于 1 且小于 99999 的正整数
    validatePeriod(rule, value, callback) {
      const num = Number(value);
      if (!Number.isFinite(num)) {
        return callback(new Error('请输入数字'));
      }
      if (!Number.isInteger(num)) {
        return callback(new Error('请输入正整数'));
      }
      if (num < 1 || num >= 99999) {
        return callback(new Error('请输入大于等于1且小于99999的正整数'));
      }
      this.updateAmount();
      callback();
    },
    // 收费体积：大于 0.01 且小于 999，最多保留两位小数
    validateVolume(rule, value, callback) {
      const raw = String(value).trim();
      // 用字符串正则判断小数位数，避免浮点误差误判（如 0.1 * 100）
      if (!/^\d+(\.\d{1,2})?$/.test(raw)) {
        return callback(new Error('请输入最多保留两位小数的正数'));
      }
      const num = Number(raw);
      if (num < 0.01 || num >= 999) {
        return callback(new Error('请输入大于等于0.01且小于999的数字'));
      }
      this.updateAmount();
      callback();
    },
    addStorageFees() {
      this.$refs.frm.validate(valid => {
        if (valid) {
          this.loading = true
          addStorageFees(this.form).then(res => {
            this.loading = false
            if (res.data.code) {
              return this.$Message.error(res.data.msg)
            }
            this.$Message.success('仓租录入成功')
            this.close()
            this.form = {
              shipmentNumber: '',
              period: 1,
              volume: 0.01,
              remarks: '',
            }
            this.$nextTick(() => {
              this.refresh();
            })
          })
        }
      })
    },
    fetchCountryWarehouse() {
      if (this.form.shipmentNumber) {
        // 从后端读取可用的仓库信息
        getWarehouseByShipmentNumber(this.form.shipmentNumber).then(res => {
          if (res.data.code) {
            // 发生错误
            return this.$Message.error(res.data.msg)
          } else {
            // 赋予仓库值
            this.form.warehouseId = res.data.payload[0]['value'];
            this.countryWarehouse = res.data.payload;
            this.$nextTick(() => {
              this.$forceUpdate();
            })
          }
        })
      }
    }
  },
  data() {
    return {
      loading: false,
      countryWarehouse: [],
      form: {
        shipmentNumber: '',
        period: 1,
        volume: 0.01,
        warehouseId: '',
        account: '',
        price: 7,
        amount: 0.07,
        remarks: '',
      },
      formRules: {
        shipmentNumber: [
          {required: true, message: '请输入订单号', trigger: 'blur'}
        ],
        period: [
          {required: true, message: '请输入收费天数', trigger: 'blur'},
          {
            validator: (...args) => this.validatePeriod(...args),
            trigger: 'blur'
          }
        ],
        volume: [
          {required: true, message: '请输入收费体积', trigger: 'blur'},
          {
            validator: (...args) => this.validateVolume(...args),
            trigger: 'blur'
          }
        ],
        warehouseId: [
          {required: true, message: '请选择服务仓库', trigger: 'change'},
        ]
      }
    }
  },
}
</script>

<template>
  <Form ref="frm" :model="form" :rules="formRules" :label-position="'right'" :label-width="80">
    <FormItem label="订单号" prop="shipmentNumber">
      <Input v-model="form.shipmentNumber" placeholder="请输入订单号" @on-blur="fetchCountryWarehouse"/>
    </FormItem>

    <FormItem label="收费天数" prop="period">
      <Input v-model="form.period" placeholder="请输入收费天数"/>
    </FormItem>

    <FormItem label="收费体积" prop="volume">
      <Input v-model="form.volume" placeholder="请输入收费体积"/>
    </FormItem>

    <FormItem label="服务仓库" prop="warehouseId">
      <Select v-model="form.warehouseId" placeholder="请输入订单号然后选择仓库"
              :disabled="countryWarehouse.length <= 0">
        <Option v-for="(v, k) in countryWarehouse" :key="'StorageFee' + k" :label="v['label']"
                :value="v['value']"></Option>
      </Select>
    </FormItem>

    <FormItem label="备注信息" prop="remarks">
      <Input v-model="form.remarks" placeholder="备注信息" :rows="3"/>
    </FormItem>

    <FormItem label="" :label-width="0">
      <Button type="primary" @click="addStorageFees" :loading="loading">录入仓租</Button>
    </FormItem>

  </Form>
</template>

<style scoped>

</style>
